import { useIdentity } from '../state/useIdentity';

export function CompanyPickerPage() {
  const { me, switchCompany, logout, error } = useIdentity();

  if (!me) {
    return null;
  }

  const inactiveCompanies = me.inactiveCompanies ?? [];

  return (
    <div className="page page--centered">
      <div className="card">
        <h1>Choose a company</h1>
        <p className="muted">Signed in as {me.email}</p>
        {error && <p className="error">{error}</p>}
        {inactiveCompanies.length > 0 && (
          <div role="alert" className="inactive-company-notice" data-testid="inactive-company-notice">
            {inactiveCompanies.map((c) => (
              <p key={c.companyName}>
                <strong>{c.companyName}</strong> is inactive in Escochex Payroll. Please contact Escochecks to choose a plan
                {' '}and reactivate it. This can happen when a trial ends without a subscription.
              </p>
            ))}
          </div>
        )}
        <ul className="company-list">
          {me.memberships.map((m) => (
            <li key={m.membershipId}>
              <button type="button" onClick={() => switchCompany(m.membershipId)}>
                {m.companyName} <span className="muted">({m.roleName})</span>
              </button>
            </li>
          ))}
        </ul>
        {me.memberships.length === 0 && inactiveCompanies.length === 0 && (
          <p className="muted">You have no active company memberships.</p>
        )}
        <button type="button" className="link" onClick={() => void logout()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
